'use strict';

function getIosVersion() {
  var version = '';
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('cpu iphone os') > 0) {
    var regStr_saf = /os [\d._]*/gi;
    var verinfo = ua.match(regStr_saf);
    version = (verinfo + '').replace(/[^0-9|_.]/ig, '');
    version && (version = version.split('_')[0]);
  }
  return version || -1;
}

module.exports = getIosVersion;